import { ICON } from "../Icon/data"

export const ICON_SELECTOR_ICONS: { [key: string]: string } = {
  arrow: ICON.CURRENT_LOCATION,
  circle: ICON.CIRCLE_SOLID
}

export const ICON_SELECTOR_COLORS: { [key: string]: string } = {
  blue: '#016CCE',
  green: '#28A048',
  red: '#D42020',
  yellow: '#F49C18'
}
